var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g(_vm._b({class:[
    'card',
    _vm.props.color ? ("card--" + (_vm.props.color)) : '',
    {
      'card--vertical-paddings-default': _vm.props.verticalPadding,
    },
    _vm.data.class,
    _vm.data.staticClass
  ],style:(_vm.data.style || _vm.data.staticStyle)},'div',_vm.data.attrs,false),_vm.data.on),[(_vm.props.title)?_c('h2',{staticClass:"text-head-2"},[_vm._v("\n    "+_vm._s(_vm.props.title)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }